import type { File, NpmPackage } from '@wix/velo-client';
import { readPackageJson, readPackageJsonContent } from '@wix/cli-fs';
import { WIX_LOCK_FILENAME } from '@wix/cli-core-definitions';
import { isWixLockExists, readWixLock } from './files/wix.lock.js';

export async function loadProjectRootFiles(projectFolder: string) {
  if (await isWixLockExists(projectFolder)) {
    const [packageJson, wixLock] = await Promise.all([
      readPackageJsonContent(projectFolder),
      readWixLock(projectFolder),
    ]);

    return [
      { path: 'package.json', content: packageJson },
      { path: WIX_LOCK_FILENAME, content: wixLock },
    ] satisfies File[];
  }

  return [];
}

export async function getProjectDependencies(projectFolder: string) {
  const packageJson = await readPackageJson(projectFolder);

  return Object.entries(packageJson.dependencies ?? {}).map<NpmPackage>(
    ([name, version]) => ({ name, version })
  );
}
